import { useCallback, useEffect, useRef, useState } from 'react'
import { useQueryClient } from 'react-query'
import { CleanedUpPlaylistAPIProps } from '../playlist/types'

export type UsePlaylist = () => CleanedUpPlaylistAPIProps | undefined

const usePlaylist: UsePlaylist = () => {
  const queryClient = useQueryClient()
  const queryCache = queryClient.getQueryCache()
  const unsubscribeFnRef = useRef<() => void>()

  const [playlistData, setPlaylistData] = useState<
    CleanedUpPlaylistAPIProps | undefined
  >(() =>
    queryClient.getQueryData<CleanedUpPlaylistAPIProps>('playlist-videos')
  )

  const updatePlaylistData = useCallback(
    (args: any) => {
      if (
        args?.action?.type === 'invalidate' &&
        args.query.queryKey === 'playlist-videos'
      ) {
        setPlaylistData(
          queryClient.getQueryData<CleanedUpPlaylistAPIProps>('playlist-videos')
        )
      }
    },
    [queryClient]
  )

  useEffect(() => {
    unsubscribeFnRef.current = queryCache.subscribe(updatePlaylistData)

    return () => {
      if (unsubscribeFnRef.current) {
        unsubscribeFnRef.current()
      }
    }
  }, [queryCache, updatePlaylistData])

  return playlistData
}

export default usePlaylist
